var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFcdOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.763 3.274a.563.563 0 00-.563.563v16.307c0 .31.252.562.563.562h3.884v1.875H5.763a2.437 2.437 0 01-2.438-2.437V3.837a2.437 2.437 0 012.438-2.438h7.392c.264 0 .516.112.694.308l5.302 5.845a.938.938 0 01.242.63v3.644h-1.875V9.12h-4.363a.937.937 0 01-.938-.938V3.274H5.763zm3.731 5.587H7.251v1.894h2.243V8.86zm-2.243 3.535h8.226v1.894H7.251v-1.894zm0 5.43V15.93h5.235v.938l-1.329.956H7.251zm12.52-4.737a.44.44 0 01.63-.001l.948.96a.46.46 0 01.002.643l-.996 1.019-1.58-1.602.995-1.019zm-1.518 1.553l1.58 1.601-6.545 6.699-1.583.01.002-1.611 6.546-6.699z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcdOutline);
export default __webpack_public_path__ + "07eca1386e12bcba511e066bf7a23e52.svg";
export { ForwardRef as ReactComponent };